import { render, staticRenderFns } from "./AppChip.vue?vue&type=template&id=01d9029c&"
import script from "./AppChip.vue?vue&type=script&lang=js&"
export * from "./AppChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports